import { View } from 'backbone';
import {Model} from 'backbone';
import _Template from 'properties/accessibility/role-state.ejs';
import _Template2 from 'properties/accessibility/state.ejs';
import listService from 'ListService.js';
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import StageAndRoleSettingsModal from 'common-views/StageAndRoleSettingsModal.js';
import settingsService from 'MandatoryAndStateSettingsService.js';
import undoService from 'UndoService';
import _ from 'lodash';

class NavAccessStateView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.options = constants.STATE_OPTIONS;
        const reducedOptions2 = ['control_clear_filter_button','control_button','control_print_button','control_page_button','control_play_form_button','control_play_report_button','control_progress_bar','control_checkbox','control_link','control_bullet_text','control_text','control_small_text','control_medium_heading','control_large_heading','control_small_heading'];
        const reducedOptions = ['page_instance','control_picture','control_movie','control_captcha','control_filter_input','control_filter_selector','control_value','control_crosstab','control_data_grid','control_data_list','control_gauge_chart','control_pie_chart','control_bar_chart','control_line_chart'];
        const stateOptions = ['control_radio_button_group','control_checkbox_group','control_group'];
        

        if (this.model.get('factoryKey')==='control_vertical_separator' ||
            this.model.get('factoryKey')==='control_horizontal_separator' ) {
            this.options = constants.REDUCED_STATE_OPTIONS;
        }

        if (reducedOptions.indexOf(this.model.get('factoryKey'))!==-1) {
            this.options = constants.REDUCED_STATE_OPTIONS;
        }

        if (reducedOptions2.indexOf(this.model.get('factoryKey'))!== -1) {
            this.options = constants.REDUCED_STATE_OPTIONS2;
        }

        if (stateOptions.indexOf(this.model.get('factoryKey'))!== -1) {
            this.options = constants.STATE_OPTIONS;
        }
        
        if(!this.model.has('state')){
            this.model.set('state', new Map(), {silent: true});
        }

        this.initValues();


        this.events = {
            'change #propState' : 'updateSelectAttributes',
            'click #browseState': 'displaySelectModal'
        };

        this.listenTo(this.model, 'change', this.render);

        this.listenTo(this.model, constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED, this.render);
        
        this.listenTo(eventBus, constants.EV_CURRENT_ROLE_OR_STAGE_UPDATED, () => {
            this.initValues();
            this.render();
        });
        
        return this;
    }

    displaySelectModal(ev){
        ev.preventDefault();
        const config = {
            settings: this.model.get('state'),
            model: this.model,
            options:this.options,
            propertyName:"value",
            defaultValue:"default",
            title: "Edit State"
        };
        const alertVIew = new StageAndRoleSettingsModal(config);
        alertVIew.render();
    }

    initValues(){
        this.role = listService.getCurrentRole();
        this.stage = listService.getCurrentStage();
    }

    getCurrentKey(){
        return `${this.stage}_${this.role}`;
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propVal = ev.currentTarget.value;

        const settings = new Map(this.model.get('state'));
        this.model.set('isStateChanging', false, {silent : true});
        this.model.set('previousStateValue', new Map(this.model.get('state')), {silent : true});        
        const oldSettings = new Map(this.model.get('state'));

        if(propVal !== this.getControlSettings()){
            const newSetting = settingsService.createSetting(listService.getCurrentStage(), listService.getCurrentRole(), 'value', propVal);
            settings.set(this.getCurrentKey(), newSetting);
            if (this.getCurrentKey() === constants.STRING_MATRIX_FULL_ENTRY){
                settings.forEach( setting => {
                setting.value = propVal; 
               });
           }
            this.model.set('state',settings);
            this.model.set('isStateChanging', true);            
            this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
        }        

        // PF-3465 Undo/Redo for Stage.
        undoService.add({
            undo: () =>{
                this.model.set('state',oldSettings);
                this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
                this.model.trigger('change');
            },
            redo:() => {
                this.model.set('state',settings);
                this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
                this.model.trigger('change');
            }
        },textConstants.UNDO_ACCESS_STATE)
    }

    getCurrentKey(){
        return listService.getCurrentStage() + '_' + listService.getCurrentRole();
    }

    getControlSettings(){
        const
            options = {
                stageId: listService.getCurrentStage(),
                roleId: listService.getCurrentRole(),
                settings: this.model.get('state'),
                defaultValue: "default",
                settingsField: "value"
            };

        return settingsService.getSetting(options);
    }

    getViewValues(){
        return {title: this.getViewTitle(), currentState:this.getCurrentState(), options:this.options};
    }

    getCurrentState(){
        const state = this.model.get('state');
        let currentValue = {value: 'default'};
        const allCurrentStage = this.stage + '_all';
        const allCurrentRole = 'all_' + this.role;
        const all = 'all_all';

        if(state.has(this.getCurrentKey())){
            currentValue = state.get(this.getCurrentKey());
        } else if(state.has(allCurrentStage)){
            currentValue = state.get(allCurrentStage);
        } else if(state.has(allCurrentRole)){
            currentValue = state.get(allCurrentRole);
        } else if(state.has(all)){
            currentValue = state.get(all);
        }


        return currentValue;
    }

    getViewTitle(){
        let title = 'State';
        const role = listService.getWorkflowRole(this.role);
        const stage = listService.getWorkflowStage(this.stage);

        if(role && stage){
            title += ' (' + stage.model.get('name') + ' - ' + role.name  + ')';
        } else if(role){
            title += ' (' + role.name + ')';
        } else if(stage){
            title += ' (' + stage.model.get('name') + ')';
        }

        return title;

    }

    render() {
        if (this.getViewTitle() === 'State') {
            this.template = _Template;
        }

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.getViewValues()));
        }

        if (listService.docType === constants.DOC_TYPE_REPORT) {
            $('#browseState').hide();
        }

        this.delegateEvents();
        return this;
    }

    
    remove() {
        this.$el.empty();
        this.undelegateEvents();
        this.stopListening();

        super.remove();
    }

}

export default NavAccessStateView;
